import PropTypes from 'prop-types';
import React from 'react';

import classnames from 'classnames';

import MaterialTypography from '../MaterialTypography/MaterialTypography';
import Spinner from '../Spinner/Spinner';
import Wrapper from './MaterialBackdrop.styled';

const MaterialBackdrop = (props) => {
  const { className, loadingText, ...rest } = props;

  return (
    <Wrapper aria-hidden="false" {...rest} className={classnames(MaterialBackdrop.displayName, className)}>
      <Spinner>
        {loadingText && <MaterialTypography className="loading-text">{loadingText}</MaterialTypography>}
      </Spinner>
    </Wrapper>
  );
};

MaterialBackdrop.displayName = 'MaterialBackdrop';

MaterialBackdrop.propTypes = {
  className: PropTypes.string,
  loadingText: PropTypes.string,
};

export default React.memo(MaterialBackdrop);
